<template>
  <div class="d-flex justify-content-center align-items-center">
    <div>
      <b-button
        variant="secondary"
        class="btn-icon rounded-circle p-3"
        size="sm"
        data-cy="see-events"
        v-on:click="seeEvents()"
      >
        <feather-icon icon="SearchIcon"/>
      </b-button>
    </div>
    <b-modal
      :id="`modal-see-events-${item.id}`"
      :title="`Eventos del email`"
      no-close-on-backdrop
      :ref="`modal-see-events-${item.id}`"
      size="lg"
      hide-footer
    >
      <b-overlay :show="loadingEventos">
        <div
          v-for="evento in eventos"
          class="row border-top"
          :key="evento.timestamp"
          style="padding: 10px"
        >
          <div class="col-2">
            {{ evento.type }}
          </div>
          <div class="col-4">
            {{ evento.timestamp | dateFormatDateTimeLocal }}
          </div>
          <div class="col-3" v-if="evento.event && evento.event.ipAddress">
            <vs-chip>
              <vs-avatar
                icon="place"
                color="green"
              />
              {{ evento.event.ipAddress }}
            </vs-chip>
          </div>
          <div class="col-3" v-if="evento.event && evento.event.delayType">
            <vs-chip>
              <vs-avatar
                icon="schedule"
                color="red"
              />
              {{ evento.event.delayType }}
            </vs-chip>
          </div>
          <div class="col-3" v-if="evento.event && evento.event.expirationTime">
            <vs-chip>
              <vs-avatar
                icon="schedule"
                color="red"
              />
              {{ evento.event.expirationTime |dateFormatDateTime }}
            </vs-chip>
          </div>
          <div v-if="evento.event && evento.event.delayedRecipients">
            <div
              class="col-4"
              v-for="destinatario in evento.event.delayedRecipients"
              :key="destinatario.emailAddress"
            >
              <vs-chip>
                <vs-avatar
                  icon="email"
                />
                {{ destinatario.emailAddress }}
              </vs-chip>
                {{ destinatario.diagnosticCode }}
            </div>
          </div>
          <div class="col-12" v-if="evento.event && evento.event.userAgent">
            <p class="text-archive">
              {{ evento.event.userAgent }}
            </p>
          </div>
          <div class="col-12" v-if="evento.event && evento.event.recipients">
            <vs-chip
              v-for="destinatario in evento.event.recipients"
              :key="destinatario"
            >
              <vs-avatar
                icon="email"
              />
              {{ destinatario }}
            </vs-chip>
          </div>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {},
  data() {
    return {};
  },
  props: [
    'item'
  ],
  computed: {
    ...mapGetters('Emails', [
      'loadingEventos',
      'eventos',
      'email'
    ]),
  },
  methods: {
    ...mapActions('Emails', [
      'setActualEmail',
      'getEmailsEvents',
      'clearEvents'
    ]),
    seeEvents() {
      if (this.email?.id !== this.item.id) {
        this.clearEvents();
      }
      this.setActualEmail(this.item);
      this.getEmailsEvents({ id: this.item.id, emailId: this.item.messageId });
      this.$refs[`modal-see-events-${this.item.id}`].show();
    }
  }
};
</script>
